var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m_header"},[_c('div',{staticClass:"banner"},[_c('img',{staticClass:"logo",attrs:{"src":require("../img/mobile/m_logo_white.png"),"alt":""}}),_c('span',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.$t('message.live'))+"\n      ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }